import css from "@styled-system/css";
import styled from "styled-components";
export { Spacer } from "../../styles";
export var FormValueSetterWrapper = styled.button(css({
    background: "transparent",
    border: "none",
    cursor: "pointer",
    display: "inline-block",
    width: "max-content"
}));

//# sourceMappingURL=styles.js.map